// 直播连接状态
export const curStateDict = {
  'DISCONNECTED': '连接断开',
  'CONNECTING': '正在连接中...',
  'RECONNECTING': '已连接',
  'CONNECTED': '正在重连中...',
  'DISCONNECTING': '正在断开连接...'
};

// 本地轨道对象错误转义
export const trackErrorDict = {
  'NOT_SUPPORTED': '当前浏览器不支持',
  'MEDIA_OPTION_INVALID': '不支持指定的分辨率或帧率',
  'DEVICE_NOT_FOUND': '找不到指定的采集设备',
  'PERMISSION_DENIED': '已取消',
  'CONSTRAINT_NOT_SATISFIED': '浏览器不支持指定的采集选项',
  'SHARE_AUDIO_NOT_ALLOWED': '屏幕共享分享音频时用户没有勾选分享音频'
};
